import React from 'react';
import styled from 'styled-components';

import LogoImage from '@/assets/svg/preloader/atlantm-primary-logo.svg';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import { colors } from '@/constants/theme';
import { fonts } from '@/constants/theme';

function Header() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    catalog: { brand, model },
  } = data;

  return (
    <Component>
      <BackgroundWrapper />

      <Name>
        {brand.name} {model?.name ?? ''}
      </Name>

      <StyledLogoImage />
    </Component>
  );
}

export default Header;

const Component = styled.div`
  position: relative;
  height: 180px;
`;

const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  background-color: ${colors.gray1400};
`;

const Name = styled.div`
  position: absolute;
  top: 56px;
  left: 41px;
  width: 450px;
  font-family: ${fonts.GrtskTera};
  font-weight: 600;
  font-size: 40px;
  text-transform: uppercase;
  white-space: normal;
  color: ${colors.blue100};
`;

const StyledLogoImage = styled(LogoImage)`
  position: absolute;
  top: 56px;
  right: 41px;
  width: 141px;
  height: 48px;
  fill: ${colors.blue100};
`;
